import {post} from '../utils'
import {makeFormData, root} from './utils'

export default host => ({ title, active, speakerId, audioFile }, onProgress) =>
  post(`${host}${root}`, makeFormData({ title, active, speakerId, audioFile }), {}, onProgress)
    .then(response => response.json())
